import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CCreateEntreprise } from './../../../../core/models/entreprise';
import {
  contactintrouvablecalloffer,
  emailSended,
} from './../../../../core/models/messages';
import { OffreEsnService } from './../../../../core/services/offre-esn/offre-esn.service';

import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-contactlistoffer',
  templateUrl: './contactlistoffer.component.html',
  styleUrls: ['./contactlistoffer.component.css'],
})
export class ContactlistofferComponent {
  contactEsnForm!: FormGroup;
  currentUser: any;
  filtered: any;
  submitted = false;

  types = [
    { value: 'Technique', id: '1' },
    { value: 'Service client', id: '2' },
    { value: 'Réclamation', id: '3' },
  ];

  selected: any = this.types[0];
  file: any;
  idResponsable: any;
  id = this.activatedRoute.snapshot.params['id'];
  constructor(
    private localStorageService: LocalStorageService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private offreesnservice: OffreEsnService,
    private router: Router
  ) {
    this.currentUser = new CCreateEntreprise();
  }

  ngOnInit() {
    this.currentUser = this.localStorageService.getData('dataUser');
    // this.id = JSON.parse(this.currentUser).id

    this.contactEsnFormGroup();
  }

  /* get id esn */

  contactEsnFormGroup() {
    this.contactEsnForm = this.formBuilder.group({
      object: ['', [Validators.required, Validators.maxLength(100)]],
      subject: ['', Validators.required],
      id: ['', Validators.required],

      file: [''],
    });
  }

  onFileChange(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files[0]) {
      const file = fileInput.files[0];
      this.file = file;
      this.contactEsnForm.get('file')?.setValue(this.file);
    }
  }

  contactEsn() {
    // this.submitted = true;
    this.contactEsnForm.markAllAsTouched();
    this.contactEsnForm.markAsDirty();
    this.contactEsnForm.patchValue({
      id: this.id,
    });
    console.log(
      '%ccontact-esn.component.ts line:64 object',
      'color: #007acc;',
      this.contactEsnForm.value
    );
    // stop here if form is invalid
    if (this.contactEsnForm.valid) {
      // this.contactEsnForm.get('user_id')?.setValue(this.id);
      console.log('contactForm', this.contactEsnForm.value);

      const formData = new FormData();
      formData.append('object', this.contactEsnForm.get('object')?.value);
      formData.append('subject', this.contactEsnForm.get('subject')?.value);
      // formData.append('user_id', this.id);
      formData.append('id', this.id);
      formData.append('file', this.contactEsnForm.get('file')?.value);

      const formDataObject: { [key: string]: any } = {};
      formData.forEach((value, key) => {
        formDataObject[key] = value;
      });

      console.log('formDataObject++', formDataObject);

      this.offreesnservice
        .contactjoboffer(formData)
        .pipe()
        .subscribe({
          next: (res) => {
            console.log('response', res);
            this.toastrService.success(emailSended);
            this.onReset();
            this.router.navigate(['/esn-offres-emploi/list-offres']);
          },
          error: (err) => {
            console.log('error', err);
            if (err?.error) {
              this.toastrService.error(contactintrouvablecalloffer);
            }
          },
        });
    }
  }

  get f() {
    return this.contactEsnForm.controls;
  }

  onSelectChange(event: any) {
    console.log('Selected:', event);
  }

  onReset() {
    this.submitted = false;
    this.contactEsnForm.reset();
    this.contactEsnForm.get('file')?.setValue('');
  }
}
